<form [formGroup]="form" novalidate>
  <div class="form-group">
    <div class="switch">
      <label>
        <input
          class="form-control"
          [(ngModel)]="displayEntityValue.useDataEntityLabel"
          formControlName="use-data-entity-label-check"
          [checked]="this.useDataEntityLabel"
          type="checkbox"
        />
        Use label from Data Entity being displayed</label
      >
    </div>
    <div class="switch">
      <label>
        <input
          class="form-control"
          [(ngModel)]="displayEntityValue.hideLabelAndValueWhenNullorEmpty"
          formControlName="hide-label-and-value-when-null-or-empty-check"
          [checked]="this.hideLabelAndValue"
          type="checkbox"
        />
        Only display label and value when there is a value</label
      >
    </div>
  </div>
  
  <div class="row form-group">
    <div class="col">
      <p>
        Data Entity to Display:
      </p>
      <p>
        <strong>{{ selectedOption }}</strong>
      </p>
    </div>
    <div *ngIf="entityRefConfigured && !searchOpened" class="col">
      <button
        class="btn btn-raised btn-primary"
        (click)="openSearch()"
      >
        Edit
      </button>
    </div>
  </div>

  <ng-container *ngIf="!entityRefConfigured || searchOpened">
    <wm-datatable
      [loading]="loading"
      [rows]="rows"
      [columns]="columns"
      [count]="page.totalElements"
      [offset]="page.pageNumber"
      [limit]="page.size"
      [allowPageSizeSelect]="false"
      [params]="params"
      id="display-data-entity-editor"
      [selectSingle]="true"
      [selected]="existingSelection"
      (selectedChanged)="onSelectedChanged($event)"
      [getId]="getId"
      [showColumnsSettings]="false"
      [showFilterBuilder]="false"
      [showSimpleSearch]="true"
      simpleSearchTitle="Search for Data Entities"
      [translateToLegacy]="false"
      (settingsChanged)="handleSettingsChanged($event)"
      [sortField]="sortField"
      [sortDescending]="sortDescending"
      [manipulateURL]="false"
    >
    </wm-datatable>
  </ng-container>
</form>
